type WidgetRoot = Pick<Element, "getAttribute">;

export function getEmbeddedWidgetReferralTag(
  element: WidgetRoot,
): string | undefined {
  const referralTag =
    element.getAttribute("referralTag") ??
    element.getAttribute("referallTag") ??
    undefined;

  return (
    referralTag
      ?.trim()
      .replace(/^["'“”‘’]+|["'“”‘’]+$/g, "")
      .trim() || undefined
  );
}
